import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "grid gap-4 md:grid-cols-2 xl:grid-cols-5",
  "aria-label": "Renewal tracking KPIs"
}
const _hoisted_2 = { class: "flex items-start justify-between gap-4" }
const _hoisted_3 = { class: "text-[0.76rem] font-extrabold uppercase tracking-[0.08em] text-[#6f7b91]" }
const _hoisted_4 = { class: "mt-3 text-[1.9rem] font-extrabold leading-none text-[#182033]" }

import { computed } from "vue";
import {
  AlertTriangle,
  CheckCircle2,
  TimerReset,
  WalletCards,
  XCircle,
} from "lucide-vue-next";
import type { RenewalKpiCounts } from "@/utils/renewalMetrics";


export default /*@__PURE__*/_defineComponent({
  __name: 'RenewalKpiCards',
  props: {
    counts: {},
    interactive: { type: Boolean },
    activeFilter: {}
  },
  emits: ["select-filter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const cards = computed(() => [
  {
    filter: "dueThisMonth" as const,
    label: "Clients Due This Month",
    value: props.counts.dueThisMonth,
    icon: WalletCards,
    iconClass: "bg-[#eef4ff] text-[#2855a6]",
  },
  {
    label: "Renewals Next Month",
    filter: "renewalsNextMonth" as const,
    value: props.counts.renewalsNextMonth,
    icon: TimerReset,
    iconClass: "bg-[#f6f0ff] text-[#6d4ad3]",
  },
  {
    label: "Overdue Renewals",
    filter: "overdueRenewals" as const,
    value: props.counts.overdueRenewals,
    icon: AlertTriangle,
    iconClass: "bg-[#fff4e8] text-[#b45309]",
  },
  {
    label: "Recently Renewed",
    filter: "recentlyRenewed" as const,
    value: props.counts.recentlyRenewed,
    icon: CheckCircle2,
    iconClass: "bg-[#ecfdf3] text-[#047857]",
  },
  {
    label: "Expired Accounts",
    filter: "expiredAccounts" as const,
    value: props.counts.expiredAccounts,
    icon: XCircle,
    iconClass: "bg-[#fff1f1] text-[#b42318]",
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards.value, (card) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.interactive ? 'button' : 'article'), {
        key: card.label,
        type: __props.interactive ? 'button' : undefined,
        "aria-pressed": __props.interactive ? __props.activeFilter === card.filter : undefined,
        "data-filter": card.filter,
        class: _normalizeClass([__props.interactive ? 'text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2' : '', "rounded-[1.25rem] border border-[rgba(218,226,238,0.95)] bg-[linear-gradient(180deg,#ffffff_0%,#f8fbff_100%)] p-5 shadow-[0_18px_36px_rgba(15,23,42,0.06)]"]),
        onClick: ($event: any) => (__props.interactive && emit('select-filter', card.filter))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(card.label), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(card.value), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl", card.iconClass])
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(card.icon), {
                class: "size-5",
                "aria-hidden": "true"
              }))
            ], 2)
          ])
        ]),
        _: 2
      }, 1032, ["type", "aria-pressed", "data-filter", "class", "onClick"]))
    }), 128))
  ]))
}
}

})